<script setup>
import { defineProps, watch, ref } from "vue";

const props = defineProps({
  type: { type: String, default: () => "" },
  errorMessage: { type: String, default: () => "Дія не вдала" },
  loadingMessage: { type: String, default: () => "Процес виконання..." },
  successMessage: { type: String, default: () => "Виконано!" },
});

const localType = ref(props.type);

watch(localType, (newType) => {
  if (newType === "success") {
    setTimeout(() => {
      localType.value = ""; // Сброс значения
    }, 700);
  }
});

watch(() => props.type, (newType) => {
  // Принудительный сброс перед установкой нового значения
  localType.value = "";
  setTimeout(() => {
    localType.value = newType;
  }, 0);
});
</script>

<template>
  <div>
    <div id="auth-error" class="alert alert-danger mb-0 p-2" :class="localType==='error'?'':'d-none'" role="alert">
      {{ errorMessage }}
    </div>

    <div id="auth-loading" class="alert alert-warning mb-0 p-2" :class="localType==='loading'?'':'d-none'" role="alert">
      {{ loadingMessage }}
    </div>

    <div id="auth-success" class="alert alert-success mb-0 p-2" :class="localType==='success'?'':'d-none'" role="alert">
      {{ successMessage }}
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>
